export default __webpack_public_path__ + "static/media/TDS Provision.5d0a0b73.xlsx";